import { workshopService } from "../service";
import { toast } from "react-toastify";
import {
  setworkshopsLoading,
 setworkshopsError,
setworkshopsData
} from "../slice/workshopSlice";
import {
  setworkshopDetailsLoading,
  setworkshopParticipantData,
  setworkshopDetailsData,
  setworkshopInventoriesData,
  setworkshopFollowUpsData,
  setresponseListData,
  settaskSettingData,
  setworkshopDetailsError
 } from "../slice/workshopDetailSlice"
import {setCompany} from '../../redux/slice/loginSlice'


const getWokshopListAsync =
(page, limit, filter,companyId,t) => async (dispatch) => {
   dispatch(setworkshopsLoading());
  try {
    const response = await workshopService.getWorkshopList(page, limit, filter,companyId);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setworkshopsError(response));
      dispatch(setworkshopsData({}));
      //toast.error(t(response?.data?.error.error_code),{ toastId: 3 });
    } else {
      dispatch(setworkshopsData(response?.data));
      dispatch(setworkshopsError({}));
    }
  } catch (error) {
    dispatch(setworkshopsError(error));
  }
}

const getWokshopParticipantListAsync =
(page, limit, filter,status,companyId,workshopId,t) => async (dispatch) => {
   dispatch(setworkshopDetailsLoading());
  try {
    const response = await workshopService.getWorkshopParticipantList(page, limit, filter,status,companyId,workshopId);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setworkshopDetailsError(response));
      dispatch(setworkshopParticipantData({}));
     // toast.error(t(response?.data?.error.error_code),{ toastId: 3 });
    } else {
      dispatch(setworkshopParticipantData(response?.data));
      dispatch(setworkshopDetailsError({}));
    }
  } catch (error) {
    dispatch(setworkshopDetailsError(error));
  }
}

const getWokshopDetailsAsync =
(companyId,workshopId,t) => async (dispatch) => {
   dispatch(setworkshopDetailsLoading());
  try {
    if(workshopId){
    const response = await workshopService.getWorkshopDetails(companyId,workshopId);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setworkshopDetailsError(response));
      dispatch(setworkshopDetailsData({}));
      //toast.error(t(response?.data?.error?.error_code),{ toastId: 3 });
    } else {
      dispatch(setworkshopDetailsData(response?.data));
      dispatch(setworkshopDetailsError({}));
      //dispatch(setCompany(response?.data.company));
    }
  }
  } catch (error) {
    dispatch(setworkshopDetailsError(error));
  }
}

const getWokshopInventoriesListAsync =
(page, limit, filter,companyId,workshopId,t) => async (dispatch) => {
   dispatch(setworkshopDetailsLoading());
  try {
    const response = await workshopService.getWorkshopInventoriesList(page, limit, filter,companyId,workshopId);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setworkshopDetailsError(response));
      dispatch(setworkshopInventoriesData({}));
     // toast.error(t(response?.data?.error.error_code),{ toastId: 3 });
    } else {
      dispatch(setworkshopInventoriesData(response?.data));
      dispatch(setworkshopDetailsError({}));
    }
  } catch (error) {
    dispatch(setworkshopDetailsError(error));
  }
}

const getInventoryResponseStatusListAsync =
(page, limit, filter,status,companyId,workshopId,inventoryId,t) => async (dispatch) => {
   dispatch(setworkshopDetailsLoading());
  try {
    const response = await workshopService.getInventoryResponseList(page, limit, filter,status,companyId,workshopId,inventoryId);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setworkshopDetailsError(response));
      dispatch(setresponseListData({}));
     // toast.error(t(response?.data?.error.error_code),{ toastId: 3 });
    } else {
      dispatch(setresponseListData(response?.data));
      dispatch(setworkshopDetailsError({}));
      //dispatch(setCompany(response?.data?.company))
    }
  } catch (error) {
    dispatch(setworkshopDetailsError(error));
  }
}

const getEvaluationResponseStatusListAsync =
(page, limit, filter,status,companyId,workshopId,t) => async (dispatch) => {
   dispatch(setworkshopDetailsLoading());
  try {
    const response = await workshopService.getEvaluationResponseList(page, limit, filter,status,companyId,workshopId);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setworkshopDetailsError(response));
      dispatch(setresponseListData({}));
     // toast.error(t(response?.data?.error.error_code),{ toastId: 3 });
    } else {
      dispatch(setresponseListData(response?.data));
      dispatch(setworkshopDetailsError({}));
    }
  } catch (error) {
    dispatch(setworkshopDetailsError(error));
  }
}

const getWokshopFollowUpListAsync =
(page, limit, filter,companyId,workshopId,t) => async (dispatch) => {
   dispatch(setworkshopDetailsLoading());
  try {
    const response = await workshopService.getWorkshopFollowUpsList(page, limit, filter,companyId,workshopId);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setworkshopDetailsError(response));
      dispatch(setworkshopFollowUpsData({}));
     // toast.error(t(response?.data?.error.error_code),{ toastId: 3 });
    } else {
      dispatch(setworkshopFollowUpsData(response?.data));
      dispatch(setworkshopDetailsError({}));
    }
  } catch (error) {
    dispatch(setworkshopDetailsError(error));
  }
}

const getFollowupResponseStatusListAsync =
(page, limit, filter,status,companyId,workshopId,followupId,t) => async (dispatch) => {
   dispatch(setworkshopDetailsLoading());
  try {
    const response = await workshopService.getFollowupResponseList(page, limit, filter,status,companyId,workshopId,followupId);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setworkshopDetailsError(response));
      dispatch(setresponseListData({}));
     // toast.error(t(response?.data?.error.error_code),{ toastId: 3 });
    } else {
      dispatch(setresponseListData(response?.data));
      dispatch(setworkshopDetailsError({}));
      //dispatch(setCompany(response?.data?.company))
    }
  } catch (error) {
    dispatch(setworkshopDetailsError(error));
  }
}

const getWokshopTaskSettings =
(companyId,workshopId,t) => async (dispatch) => {
   dispatch(setworkshopDetailsLoading());
  try {
    const response = await workshopService.getTaskSettings(companyId,workshopId);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setworkshopDetailsError(response));
      dispatch(settaskSettingData({}));
     // toast.error(t(response?.data?.error.error_code),{ toastId: 3 });
    } else {
      dispatch(settaskSettingData(response?.data));
      dispatch(setworkshopDetailsError({}));
    }
  } catch (error) {
    dispatch(setworkshopDetailsError(error));
  }
}

export const workshopAction = {
    getWokshopListAsync,
    getWokshopParticipantListAsync,
    getWokshopDetailsAsync,
    getWokshopInventoriesListAsync,
    getInventoryResponseStatusListAsync,
    getEvaluationResponseStatusListAsync,
    getWokshopFollowUpListAsync,
    getFollowupResponseStatusListAsync,
    getWokshopTaskSettings

  };